import { DatePickerPresetsOptions, DateRange } from '@clickcease/cc-client-components-lib'
import { add, startOfDay } from 'date-fns'

import i18n from 'Lib/i18n'

import { RangeOptionKey } from './types'

const getRange: (from: Date) => DateRange = (from) => ({
  from,
  to: new Date(),
})

export type DatePickerOption = {
  key: keyof typeof RangeOptionKey | undefined
  label: string
}

export const rangeOptions: Record<
  keyof typeof RangeOptionKey,
  { value: DatePickerPresetsOptions | 'custom'; range?: DateRange }
> = {
  TODAY: {
    value: 'today',
    get range() {
      return getRange(startOfDay(add(new Date(), { days: -1 })))
    },
  },
  WEEK: {
    value: 'week',
    get range() {
      return getRange(startOfDay(add(new Date(), { weeks: -1 })))
    },
  },
  MONTH: {
    value: 'month',
    get range() {
      return getRange(startOfDay(add(new Date(), { months: -1 })))
    },
  },
  THREE_MONTHS: {
    value: '3months',
    get range() {
      return getRange(startOfDay(add(new Date(), { months: -3 })))
    },
  },
  CUSTOM: {
    value: 'custom',
  },
} as const

export const DAY_PICKER_OPTIONS: { key: keyof typeof RangeOptionKey; label: string }[] = [
  {
    key: 'TODAY',
    label: i18n.t(`calendar.today`, { ns: 'general' }),
  },
  {
    key: 'WEEK',
    label: i18n.t(`calendar.week`, { ns: 'general' }),
  },
  {
    key: 'MONTH',
    label: i18n.t(`calendar.month`, { ns: 'general' }),
  },
  {
    key: 'THREE_MONTHS',
    label: i18n.t(`calendar.3months`, { ns: 'general' }),
  },
  {
    key: 'CUSTOM',
    label: i18n.t(`calendar.custom`, { ns: 'general' }),
  },
]
